import React, { useState, useEffect, useRef, useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { getBranding } from "../../hooks/tennant";
import Notifications from "../notifications/notifications";
import Account from "../account/account";
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import BackupTableRoundedIcon from '@mui/icons-material/BackupTableRounded';
import LocalGasStationRoundedIcon from '@mui/icons-material/LocalGasStationRounded';
import axiosInstance from "../../api/axiosInstance";
import "../navbar/navbar.scss"

const Navbar = () => {
    const [openModal, setOpenModal] = useState(null);
    const [branding, setBranding] = useState(null);
    const [unread, setUnread] = useState(0);

    const { user, hasPermission, isLoading } = useContext(AuthContext);
    const modalRef = useRef(null);

    useEffect(() => {
        const loadBranding = async () => {
            try {
                const data = await getBranding();
                setBranding(data);
            } catch (error) {
                console.error("Branding konnte nicht geladen werden:", error);
            }
        };

        loadBranding();
    }, []);

    useEffect(() => {
        const loadUnread = async () => {
            try {
                const response = await axiosInstance.get(
                    "notifications",
                    { withCredentials: true }
                );

                setUnread(Number(response.data.unread));
            } catch (error) {
                console.error(
                    "Anzahl ungelesener Benachrichtigungen konnte nicht geladen werden:",
                    error
                );
            }
        };

        if (user) {
            loadUnread();
        }
    }, [user]);

    const handleClick = () => {
        setOpenModal(prev => (prev === "account" ? null : "account"));
    };

    const handleClickNotifications = () => {
        setOpenModal(prev => (prev === "notifications" ? null : "notifications"));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setOpenModal(null);
            }
        };

        if (openModal) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openModal]);

    return isLoading ? (<div />) : (
        <div className="nav">
            <div className="topBar">
                <div className="left">
                    {branding &&
                        <NavLink to="/">
                            <img src={`/assets/branding/${branding.logoNav}`} alt="Logo" className="logo" />
                        </NavLink>
                    }
                    <div className="navigation">
                        {hasPermission("map", "read") &&
                            <NavLink to="/map" className="block">
                                <MapRoundedIcon />
                                <span>Karte</span>
                            </NavLink>
                        }
                        {hasPermission("planner", "read") &&
                            <NavLink to="/calendar" className="block">
                                <EventRoundedIcon />
                                <span>Kalender</span>
                            </NavLink>
                        }
                        {hasPermission("planner", "read") &&
                            <NavLink to="/list" className="block">
                                <ChecklistRoundedIcon />
                                <span>Auftragsliste</span>
                            </NavLink>
                        }
                        {hasPermission("data", "read") &&
                            <NavLink to="/data" className="block">
                                <BackupTableRoundedIcon />
                                <span>Stammdaten</span>
                            </NavLink>
                        }
                        {hasPermission("tankstelle", "read") &&
                            <NavLink to="/tankstelle" className="block">
                                <LocalGasStationRoundedIcon />
                                <span>Tankstelle</span>
                            </NavLink>
                        }
                        {hasPermission("company", "read") &&
                            <NavLink to="/customer" className="block">
                                <PeopleOutlineRoundedIcon />
                                <span>Kundenstammdaten</span>
                            </NavLink>
                        }
                        {hasPermission("company", "read") &&
                            <NavLink to="/deliverynotes" className="block">
                                <DescriptionOutlinedIcon />
                                <span>Lieferscheine</span>
                            </NavLink>
                        }
                        {hasPermission("company", "read") &&
                            <NavLink to="/bills" className="block">
                                <ReceiptLongRoundedIcon />
                                <span>Rechnungen</span>
                            </NavLink>
                        }
                        {hasPermission("operator", "read") &&
                            <NavLink to="/operator" className="block">
                                <ChecklistRoundedIcon />
                                <span>Fahrten</span>
                            </NavLink>
                        }
                    </div>
                </div>
                {user &&
                    <div className="right" ref={modalRef}>
                        <div className="notificationsButton" onClick={handleClickNotifications}>
                            {unread > 0 && <span className="dot">{unread}</span>}
                            <NotificationsNoneRoundedIcon />
                        </div>
                        {openModal === "notifications" && (
                            <div className="popUp">
                                <Notifications onUnreadChange={setUnread} />
                            </div>
                        )}
                        <div className="accountButton" onClick={handleClick}>
                            <span>{user?.username?.[0]}</span>
                        </div>
                        {openModal === "account" &&
                            <div className="popUp">
                                <Account handleClick={handleClick} />
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    )
};

export default Navbar;